import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../api-response';
import { BaseApiService } from '../../../core/base-api.service';
import { FeedDiagnostics } from '../../../shared/models/feed-diagnostics.model';

/** Cross-tenant read of every feed's latest diagnostics snapshot —
 *  /api/v1/admin/feeds/diagnostics. Super-admin only, bypasses
 *  tenant filtering entirely. Ordered by receivedAt DESC, no pagination. */
@Injectable({ providedIn: 'root' })
export class ProviderDiagnosticsAdminService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly diagnosticsUrl = `${this.coreApiUrl}/api/v1/admin/feeds/diagnostics`;

  /** `payload` is provider-specific JSON and varies per entry (mixed
   *  provider types in one response) — left as `unknown`; narrow per-entry
   *  using each entry's `providerType` where needed.
   *
   *  `providerType` filters to an exact match on the column parsed from the
   *  AMQP routing key (e.g. "siri") — a plain equality, not a lookup against
   *  the provider table, since provider_type is treated as free text. Omit
   *  it to get every feed of every provider type, unfiltered. */
  getAll(providerType?: string): Observable<ApiResponse<FeedDiagnostics[]>> {
    const params = providerType ? new HttpParams().set('providerType', providerType) : undefined;
    return this.http.get<ApiResponse<FeedDiagnostics[]>>(this.diagnosticsUrl, { params });
  }
}
